module.exports = __webpack_public_path__ + "img/everest.3458cc9c.jpg";